import { Injectable } from '@angular/core';

import { Partner } from '../../model/partner.model';

/**
 *
 * Partner Config Service
 * @export
 * @ class PartnerConfigService
 */
@Injectable()
export class PartnerConfigService {
  /** static instance */
  public static instance: PartnerConfigService = undefined;
  /** Return Partners */
  private partners: Partner[];

  /**
   * Creates an instance of PartnerConfigService.
   * memberof PartnerConfigService
   */
  constructor() {}

  /**
   * Get Instance of partner config service
   * static
   * returns
   * memberof PartnerConfigService
   */
  public static getInstance(): PartnerConfigService {
    if (!PartnerConfigService.instance) {
      PartnerConfigService.instance = new PartnerConfigService();
      PartnerConfigService.instance.partners = [];
    }
    return PartnerConfigService.instance;
  }

  /**
   * Set Partners
   * param {Partner[]} partners
   * memberof PartnerConfigService
   */
  public setPartners(value: Partner[]): void {
    this.partners = value;
  }

  /**
   * Get Partners
   * returns {Partner[]}
   * memberof PartnerConfigService
   */
  public getPartners(): Partner[] {
    return this.partners;
  }

  /**
   * Get Partner information by partner id.
   * param {number} partnerId
   * returns {Partner}
   * memberof PartnerConfigService
   */
  public getPartner(partnerId: number): Partner {
    let partner: Partner;

    if (this.partners && this.partners.length > 0) {
      partner = this.partners.find((p) => p.partnerId === partnerId);
    }

    return partner;
  }
}
